import { request } from './util';

export async function assignVd(params) {
  return request({
    scope: 'portal',
    name: 'session/assign-vd',
    data: params,
  });
}

export async function unassignVds(payload) {
  await request({
    scope: 'portal',
    name: 'session/unassign-vd',
    data: {
      ...payload,
    },
  });
}

export async function getSessionUser() {
  return request({
    scope: 'portal',
    name: 'session/get-session-user',
    data: {},
  });
}

export async function getRequieredProgram() {
  return request({
    scope: 'portal',
    name: 'session/get-required-program',
    data: {},
  });
}

export async function getCustomRedirect() {
  return request({
    scope: 'portal',
    name: 'session/get-custom-redirect',
    data: {},
  });
}

export async function getCustomClient() {
  return request({
    scope: 'portal',
    name: 'session/get-custom-client',
    data: {},
  });
}
